import { TValidTestId } from 'types/context-role-element.types';
import BreadcrumbContext from './breadcrumb';
import HeaderContext from './header';

export default {
  ...BreadcrumbContext,
  ...HeaderContext,
} as TValidTestId;
